/**
 * サイト基本情報
 *
 * 法務ページ・フッター・お問い合わせで共通利用する。
 * 変更はこのファイル1箇所で完結する。
 */

export const SITE_NAME = 'force.gg'

export const SITE_URL = 'https://www.forcegg.io'

/** 運営者表記 */
export const OPERATOR_NAME = 'vellkoma'

/**
 * お問い合わせ用メールアドレス
 *
 * ⚠️ 未設定: forcegg.io ドメインでこのアドレスの受信設定が必要です。
 *    設定方法の例:
 *      - Cloudflare Email Routing（無料・転送のみ）
 *      - Google Workspace（有料・独立した受信箱）
 *    受信できるようになるまで、お問い合わせは届きません。
 */
export const CONTACT_EMAIL = 'contact@forcegg.io'
